import axios from 'axios';

const RESOURCE_NAME = '/exports';

export default {

    exportStartups(searchType, startupsIds, columns) {
        return axios.post(`${RESOURCE_NAME}/export-startups`, {search_type: searchType, startup_ids: startupsIds, columns: columns})
    },

    exportStartupsByQuery(searchType, query, sort, columns) {
        return axios.post(`${RESOURCE_NAME}/export-startups`, {search_type: searchType, query: query, sort: sort, columns: columns})
    },

    exportStartupsFromTracker(trackerId, startupsIds, columns) {
        return axios.post(`${RESOURCE_NAME}/export-startups?tracker_id=${trackerId}`, {search_type: 'startups', startup_ids: startupsIds, columns: columns})
    },

    exportAllStartupsFromTracker(trackerId, columns) {
        return axios.post(`${RESOURCE_NAME}/export-startups?tracker_id=${trackerId}`, {search_type: 'startups', columns: columns})
    },

    exportStartupsContactsFromTracker(trackerId, startupsIds) {
        return axios.post(`${RESOURCE_NAME}/export-startups-contacts?tracker_id=${trackerId}`, {startup_ids: startupsIds})
    },

    exportAllStartupsContactsFromTracker(trackerId) {
        return axios.post(`${RESOURCE_NAME}/export-startups-contacts?tracker_id=${trackerId}`)
    },

    exportStartupsContacts(startupsIds) {
        return axios.post(`${RESOURCE_NAME}/export-startups-contacts`, {startup_ids: startupsIds})
    },
}